import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api, formatINR } from "../lib/api";

export default function Gifts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products", { params: { product_type: "gift" } })
      .then(({ data }) => setProducts(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-10 lg:py-20" data-testid="gifts-page">
        <p className="label-tiny mb-3 flex items-center gap-2">
          <Gift className="h-3.5 w-3.5" /> Occasional finds
        </p>
        <h1 className="font-serif text-4xl text-[#2a2928] sm:text-5xl lg:text-6xl" data-testid="gifts-heading">
          Little extras, <span className="italic text-[#d08c8c]">seasonally curated.</span>
        </h1>
        <p className="mt-4 max-w-2xl text-[#7a7571]">
          Standalone gifts we drop from time to time — for the occasions that don&apos;t need a full hamper.
          Available while stocks last.
        </p>

        <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3" data-testid="gifts-grid">
          {loading && [...Array(3)].map((_, i) => (
            <div key={i} className="animate-pulse">
              <div className="aspect-[4/5] rounded-3xl bg-[#f0e9e1]" />
            </div>
          ))}
          {!loading && products.length === 0 && (
            <div className="col-span-full rounded-3xl border border-dashed border-[#e8e2da] py-20 text-center text-[#7a7571]" data-testid="gifts-empty">
              No occasional gifts right now. Check back around festival time!
            </div>
          )}
          {!loading && products.map((p) => (
            <Link
              to={`/product/${p.id}`}
              key={p.id}
              data-testid={`gift-product-${p.id}`}
              className="group card-lift"
            >
              <div className="overflow-hidden rounded-3xl border border-[#e8e2da] bg-white">
                <div className="aspect-[4/5] overflow-hidden">
                  <img src={p.image_base64 || p.image_url} alt={p.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
              </div>
              <div className="mt-4 flex items-start justify-between gap-4">
                <div>
                  <p className="text-xs uppercase tracking-[0.18em] text-[#7a7571]">Gift</p>
                  <h3 className="mt-1 font-serif text-xl text-[#2a2928]">{p.name}</h3>
                </div>
                <div className="whitespace-nowrap font-serif text-lg text-[#2a2928]">{formatINR(p.price)}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
